export default "__VITE_ASSET__d4b63724__"